const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg/route.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { internalTimelineExportSearchSchema } from '@/components/views/export/ExportTimelinePage';

/**
 * Export route for timeline SVG generation with token authentication.
 *
 * Renders the same static, de-virtualized timeline layout as the PNG route
 * (the SVG export worker walks the live DOM and emits SVG primitives — it
 * relies on every row/column being present in the DOM, not just the visible
 * viewport). ExportTimelinePage renders the standard TimelineTable, which has
 * no column virtualizer and flattens all rows in export mode, so the full
 * content is already laid out for the walk.
 *
 * Authentication: JWT token passed via ?token= query parameter (validated by backend API).
 * URL Pattern: /export/v1/loop-visualization/view/:viewId/visualization/:visualizationId/timeline/svg?token={jwt}&...
 */
export const Route = createFileRoute('/(unauthenticated)/export/v1/loop-visualization/view/$viewId/visualization/$visualizationId/timeline/svg')({
  validateSearch: zodValidator(internalTimelineExportSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});